/*=========================================================================================
  File Name: module-invoice-check-history-mutations.js
  Description: InvoiceCheckHistory Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
export default {
	updateHistorys(state, res) {
		state.InvoiceCheckHistorys.removeAll();
		state.InvoiceCheckHistorys = [...res];
	}
};
